module.exports = __webpack_public_path__ + "img/orderEmpty.927d394c.png";